(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6055);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(9472);
// EXTERNAL MODULE: ./src/components/blocks/process/index.ts + 28 modules
var process = __webpack_require__(5508);
// EXTERNAL MODULE: ./src/data/process.ts + 1 modules
var data_process = __webpack_require__(9870);
// EXTERNAL MODULE: ./src/components/blocks/testimonial/index.ts + 29 modules
var testimonial = __webpack_require__(659);
// EXTERNAL MODULE: ./src/components/blocks/services/index.ts + 33 modules
var services = __webpack_require__(587);
// EXTERNAL MODULE: ./src/components/blocks/portfolio/index.ts + 25 modules
var portfolio = __webpack_require__(362);
;// CONCATENATED MODULE: ./src/data/faq.ts
// used in the faq-1 block
var faq_accordionList1 = [
    [
        {
            no: "One",
            expand: false,
            heading: "Can I cancel my subscription?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        },
        {
            no: "Two",
            expand: false,
            heading: "Which payment methods do you accept?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        },
        {
            no: "Three",
            expand: false,
            heading: "How can I manage my Account?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        }
    ],
    [
        {
            no: "Four",
            expand: false,
            heading: "How do I get my subscription receipt?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        },
        {
            no: "Five",
            expand: false,
            heading: "Are there any discounts for people in need?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        },
        {
            no: "Six",
            expand: false,
            heading: "Do you offer a free trial edit?",
            body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
        }
    ]
];
// used in the faq-2 block
var accordionList2 = [
    {
        no: 1,
        expand: false,
        heading: "Website health check",
        body: "We use advanced tools to perform a complete check of your website, looking at everything from page content to technical issues. We identify areas for improvement and recommend fixes to help your website grow and perform better in search results.",
        body2: ""
    },
    {
        no: 2,
        expand: false,
        heading: "Penalty removal",
        body: "If your site has been penalized by search engines (like Google), we can help you figure out why and get your rankings back on track. Our tools will spot any penalties and create a plan to recover your site’s visibility.",
        body2: ""
    },
    {
        no: 3,
        expand: false,
        heading: "Clickable content",
        body: "We create content designed to match what people are searching for online. Using data, we make sure the content attracts attention, builds links, and ranks well on search engines.",
        body2: ""
    },
    {
        no: 4,
        expand: false,
        heading: "User experience",
        body: "We review your site’s design and navigation, comparing it to best practices to make sure it’s easy for users to find what they need. Our goal is to improve the overall user experience and help turn visitors into customers.",
        body2: ""
    },
    {
        no: 5,
        expand: false,
        heading: "Website optimisation",
        body: "We analyze the technical side of your content management system (CMS) and recommend ways to improve it for better search engine results, whether you’re running a blog, news site, or online store.",
        body2: ""
    },
    {
        no: 6,
        expand: false,
        heading: "AI keyword research",
        body: "We use smart AI tools to research which keywords are most relevant to your business and how your site is performing. This helps us target the best keywords and fill in any gaps where competitors are outranking you.",
        body2: ""
    },
    {
        no: 7,
        expand: false,
        heading: "AI & Human Content",
        body: "Create and then edit AI content. You have to explain your services clearly and in an engaging manner to let Google know you mean business.",
        body2: ""
    },
    {
        no: 8,
        expand: false,
        heading: "Strong backlinks",
        body: "We help your site gain credibility by building high-quality backlinks. These are links from other websites that point to yours, boosting your authority in search engines and improving your chances of ranking higher.",
        body2: ""
    },
    {
        no: 9,
        expand: false,
        heading: "Website performance",
        body: "We ensure your website loads quickly and runs smoothly by analyzing and improving its performance. Fast load times improve your search rankings and create a better experience for users.",
        body2: ""
    },
    {
        no: 10,
        expand: false,
        heading: "Analytics & support",
        body: "We provide ongoing support with tools like Google Analytics to track your website’s performance and make adjustments based on real-time data. This helps us continually improve your site and maintain strong search rankings.",
        body2: ""
    }
];
// used in the faq-2 block
var accordionList99 = [
    {
        no: 1,
        expand: false,
        heading: "Why do we need to conduct an SEO audit?",
        body: "To find out where your website is in terms of search engine optimisation, you should do an SEO audit. An SEO audit can boost your site's search engine rankings by analysing its current state and making recommendations for how to better optimise its content and structure.",
        body2: ""
    },
    {
        no: 2,
        expand: false,
        heading: "When should you schedule an SEO audit?",
        body: "An SEO audit's duration is highly sensitive to the site's size and complexity. A typical SEO audit conducted by SEOptimist takes between one and two weeks to complete.",
        body2: ""
    },
    {
        no: 3,
        expand: false,
        heading: "What information does an SEO audit include?",
        body: "Your website's current SEO state will be evaluated and recommendations for enhancements to the site's structure, content, keywords, backlink profile, and social media presence will be included in the SEO audit report. An implementation strategy for these suggestions is possible in the paper.",
        body2: ""
    },
    {
        no: 4,
        expand: false,
        heading: "Technical SEO Audit",
        body: "Conduct an audit to identify quick wins and medium-term goals for content and site performance. Present strategy and reports to the client in one easy-to-read tailored document.",
        body2: ""
    },
    {
        no: 5,
        expand: false,
        heading: "Priority Technical Error Fixing",
        body: "We prioritise fixing the most pressing technical issues including Google indexing, caching and page speed. All new sites are built to Accessibility standards and pass Lighthouse testing from the first commit to finish. ",
        body2: "All current requirements are baked into our site code."
    },
    {
        no: 6,
        expand: false,
        heading: "AI enabled SEO keyword research",
        body: "We use the AI powered SEMRush API, Google AI, and Ahrefs to conduct the majority of our keyword research, alongside Google AI suggestions and AHREFS. We conduct keyword research by casting a wide net over your competitors and see how they are being found by web users.",
        body2: ""
    },
    {
        no: 7,
        expand: false,
        heading: "AI keyword grouping",
        body: "Keywords are grouped by relevance and ease of success in ranking. These keywords and sub keywords are then used to create the site structure. This, as you can imagine, is a lot of data. Sorting is a huge task and in the hands of a human, messy and too time consuming.",
        body2: "Using a combination of AI and data sorting scripting, we are able to sift out unrelated keywords. This allows us to focus on the keywords that have relatively high search volume but a low amount of competing web pages: quick wins. Currently, the common practice is to group together 5 keywords per page, with one main keyword forming the page title and main heading. Here, AI helps by finding ingenious ways of combining keywords into super keyword phrases."
    },
    {
        no: 8,
        expand: false,
        heading: "AI/Manual content creation",
        body: "Create and edit AI content and/or provide keywords, site structure and template to client for content creation. Content generation - your website content is important for two reasons. The obvious reason is that you have to explain your services clearly and engagingly. ",
        body2: "AI can help cut down this time by half, clearly structuring your ideas so you don't have to spend ages planning. It is suggested that clients produce YouTube content if possible. We improve our clients' ROI by analysing website users, creating optimised pages. Optionally, we provide A/B testing to measure the real increase in sales."
    },
    {
        no: 9,
        expand: false,
        heading: "On-page and off-page linking strategy",
        body: "Develop a linking strategy based on desired sales conversion pages and make monthly recommendations for external links. Link weight is given to particular pages based on the client's desired sales conversion pages. We will make monthly recommendations for external links that will boost site visibility. We also offer an article placement service as well as approaching external sites for links. ",
        body2: "Link building from other websites back to your own helps search engines determine how authoritative your website is and can help improve its ranking. Link building should be done carefully and with strategic planning to ensure that the links are from reputable websites that are related to the topic of your website. Using keywords in anchor text further improves rankings."
    },
    {
        no: 10,
        expand: false,
        heading: "Review, refine, repeat",
        body: "Reoptimise strategy in light of Google positions and conversion rates. We never cut corners. All issues are recorded and priority is placed on tasks that will have the most positive effect on sales and user experience. Update client on progress and make recommendations for the next phase via members dashboard.",
        body2: "Monitor / add funnels to Google Analytics."
    }
];
// used in the faq-6 block
var accordionList3 = [
    {
        no: "One",
        expand: false,
        heading: "How do I get my subscription receipt?",
        body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
    },
    {
        no: "Two",
        expand: false,
        heading: "Are there any discounts for people in need?",
        body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
    },
    {
        no: "Three",
        expand: false,
        heading: "Do you offer a free trial edit?",
        body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
    },
    {
        no: "Four",
        expand: false,
        heading: "How do I reset my Account password?",
        body: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Cras justo odio, dapibus ac facilisis."
    }
];

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ1.tsx


// -------- data -------- //

var FAQ1 = function() {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "fs-15 text-uppercase text-muted mb-3 text-center",
                children: "FAQ"
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: "display-4 mb-10 px-lg-12 px-xl-15 text-center",
                children: "If you don't see an answer to your question, you can send us an email from our contact form."
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "accordion-wrapper",
                id: "accordion",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: accordionList1.map(function(items, i) {
                        return /*#__PURE__*/ _jsx("div", {
                            className: "col-md-6"
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var faq_FAQ1 = ((/* unused pure expression or super */ null && (FAQ1)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/reuseable/accordion/index.tsx


// ==================================================
var accordion_Accordion = function(param) {
    var id = param.id, keyValue = param.keyValue, no = param.no, subNav = param.subNav, expand = param.expand, body = param.body, body2 = param.body2, heading = param.heading;
    var pathname = (0,router.useRouter)().pathname;
    // Generate unique IDs for the accordion elements
    var headerId = "heading-".concat(no);
    var collapseId = "collapse-".concat(no);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card  accordion-item",
        style: subNav ? {
            width: "250px"
        } : {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-header p-0 pb-1 ps-3 bg-black",
                id: headerId,
                style: {
                    paddingBottom: 10,
                    borderRadius: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    id: id,
                    "data-bs-toggle": "collapse",
                    "aria-controls": collapseId,
                    "data-bs-target": "#".concat(collapseId),
                    "aria-expanded": expand ? "true" : "false",
                    style: {
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        border: "none",
                        color: "#fff",
                        fontWeight: "normal"
                    },
                    className: "pt-1 ps-1 my-1 accordion-button ".concat(expand ? "" : "collapsed", " ").concat(subNav ? "fs-14" : ""),
                    children: [
                        pathname === "/" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "icon btn btn-circle btn-primary pe-none me-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "number fs-18 p-0",
                                children: no
                            })
                        }),
                        heading
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: collapseId,
                "aria-labelledby": headerId,
                className: "accordion-collapse pt-0 collapse ".concat(expand ? "show" : ""),
                style: {
                    width: "100%",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card-body w-full h-full h-100 w-100 p-0 pt-2 px-4 pb-3",
                    style: {
                        color: "#9fa5af",
                        width: "100%",
                        height: "100%",
                        background: "#000"
                    },
                    children: body
                })
            })
        ]
    }, keyValue);
};
/* harmony default export */ var reuseable_accordion = (accordion_Accordion);

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ2.tsx



// ============================================================
var FAQ2 = function(param) {
    var title1 = param.title1, title2 = param.title2, subtitle = param.subtitle, placeholder = param.placeholder, movie = param.movie, accordion = param.accordion, body = param.body, fontsize1 = param.fontsize1, fontsize2 = param.fontsize2, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? "primary" : _titleColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "point-process",
        className: "video-hero wrapper angled lower-start pt-15 pt-md-17",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "display-2 mt-3 mb-0 text-center",
                style: {
                    color: "#ccc",
                    background: "none"
                },
                children: [
                    title1,
                    " ",
                    title2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row animate__animated animate__slideInUp animate__delay-2s",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " col-12 mx-auto text-center mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "display-4 mb-5 text-capitalize",
                        style: {
                            color: "#ccc"
                        },
                        children: [
                            "for SEO Success",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row animate__animated animate__slideInUp animate__delay-2s",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-10 col-md-11 mx-auto text-center mb-10",
                    style: {
                        color: "#ccc"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "With our unique, data-driven SEO process, we don't just improve your website's rankings — we drive more traffic, boost visibility, and ultimately convert that traffic into sales. "
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row w-100 mb-md-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto col-sm-10 col-md-8 col-lg-6 col-xl-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        className: "animate__animated animate__slideInUp animate__delay-3s accordion-wrapper w-100 p-0",
                        id: "accordion",
                        children: accordion.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_accordion, (0,src_object_spread/* default */.Z)({
                                keyValue: item.no
                            }, item), item.no);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var faq_FAQ2 = (FAQ2);

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ3.tsx

var FAQ3 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card bg-soft-primary rounded-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card-body p-md-10 p-xl-11",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-4",
                                children: "Frequently Asked Questions"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-0",
                                children: "If you don't see an answer to your question, you can send us an email from our contact form."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "accordion accordion-wrapper",
                            id: "accordionExample"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var faq_FAQ3 = ((/* unused pure expression or super */ null && (FAQ3)));

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
;// CONCATENATED MODULE: ./src/components/reuseable/counter/Counter1.tsx


// ====================================================
var Counter1 = function(param) {
    var title = param.title, number = param.number, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? "" : _titleColor;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-md-4",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "counter counter-lg ".concat(titleColor),
                children: /*#__PURE__*/ _jsx(CountUp, {
                    end: number,
                    suffix: "+"
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                children: title
            })
        ]
    });
};
/* harmony default export */ var counter_Counter1 = ((/* unused pure expression or super */ null && (Counter1)));

;// CONCATENATED MODULE: ./src/components/reuseable/counter/Counter2.tsx


// ===================================================
var Counter2_Counter2 = function(param) {
    var amount = param.amount, title = param.title;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-6 col-lg-3",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "counter counter-lg text-white",
                children: /*#__PURE__*/ _jsx(CountUp, {
                    end: amount
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                children: title
            })
        ]
    });
};
/* harmony default export */ var counter_Counter2 = ((/* unused pure expression or super */ null && (Counter2_Counter2)));

;// CONCATENATED MODULE: ./src/components/reuseable/counter/Counter3.tsx



// ====================================================
var Counter3 = function(param) {
    var title = param.title, number = param.number, Icon = param.Icon, suffix = param.suffix;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-md-4",
        children: [
            Icon,
            /*#__PURE__*/ _jsx("h3", {
                className: "counter",
                children: /*#__PURE__*/ _jsx(CountUp, _object_spread({
                    end: number
                }, suffix && {
                    suffix: suffix
                }))
            }),
            /*#__PURE__*/ _jsx("p", {
                children: title
            })
        ]
    });
};
/* harmony default export */ var counter_Counter3 = ((/* unused pure expression or super */ null && (Counter3)));

;// CONCATENATED MODULE: ./src/components/reuseable/counter/index.ts





// EXTERNAL MODULE: ./src/data/demo-11.ts
var demo_11 = __webpack_require__(9190);
;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ4.tsx



// -------- data -------- //

var FAQ4 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row mt-md-n50p mb-14 mb-md-7",
        children: /*#__PURE__*/ _jsx("div", {
            className: "col-xl-10 mx-auto",
            children: /*#__PURE__*/ _jsx("div", {
                className: "card image-wrapper bg-full bg-image bg-overlay bg-overlay-400",
                style: {
                    backgroundImage: "url(/img/photos/bg2.jpg)"
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body p-9 p-xl-11",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row align-items-center counter-wrapper gy-8 text-center text-white",
                        children: facts.map(function(item) {
                            return /*#__PURE__*/ _jsx(Counter2, _object_spread({}, item), item.id);
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var faq_FAQ4 = ((/* unused pure expression or super */ null && (FAQ4)));

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ5.tsx

// -------- data -------- //

var FAQ5 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row gx-md-8 gx-xl-12 gy-10",
        children: faq.map(function(item) {
            return /*#__PURE__*/ _jsx("div", {
                className: "col-lg-6",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex flex-row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "icon btn btn-sm btn-circle btn-primary pe-none me-5",
                                children: /*#__PURE__*/ _jsx("i", {
                                    className: "uil uil-comment-exclamation"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    children: item.title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-0",
                                    children: item.description
                                })
                            ]
                        })
                    ]
                })
            }, item.id);
        })
    });
};
/* harmony default export */ var faq_FAQ5 = ((/* unused pure expression or super */ null && (FAQ5)));

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ6.tsx


var FAQ6 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-light",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "container pt-6 pb-14 pb-md-16",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-8 gx-xl-12 gy-10",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6 mb-0",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "fs-16 text-uppercase text-primary mb-4",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-3 mb-4",
                                    children: "If you don't see an answer to your question, you can send us an email from our contact form."
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-6",
                                    children: "Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Nullam quis risus eget urna mollis ornare."
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "All FAQ",
                                    href: "#",
                                    className: "btn btn-primary rounded-pill"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "accordion-wrapper",
                                id: "accordion"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "divider text-navy mx-n2",
                    children: /*#__PURE__*/ _jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 100",
                        children: /*#__PURE__*/ _jsx("path", {
                            fill: "currentColor",
                            d: "M1260,1.65c-60-5.07-119.82,2.47-179.83,10.13s-120,11.48-180,9.57-120-7.66-180-6.42c-60,1.63-120,11.21-180,16a1129.52,1129.52,0,0,1-180,0c-60-4.78-120-14.36-180-19.14S60,7,30,7H0v93H1440V30.89C1380.07,23.2,1319.93,6.15,1260,1.65Z"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var faq_FAQ6 = ((/* unused pure expression or super */ null && (FAQ6)));

// EXTERNAL MODULE: ./src/data/demo-27.ts + 6 modules
var demo_27 = __webpack_require__(4823);
;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQ7.tsx

// -------- data -------- //

var FAQ7 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row",
        children: /*#__PURE__*/ _jsx("div", {
            className: "col-xl-11 mx-auto",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row gx-md-8 gx-xl-12 gy-10 px-lg-5",
                children: data.faqList.map(function(param) {
                    var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                    return /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-row",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Icon, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "fs-20 ls-sm",
                                            children: title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-0",
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, id);
                })
            })
        })
    });
};
/* harmony default export */ var faq_FAQ7 = ((/* unused pure expression or super */ null && (FAQ7)));

;// CONCATENATED MODULE: ./src/components/blocks/faq/FAQjson.tsx



// ============================================================
var FAQjson_FAQ2 = function(param) {
    var title1 = param.title1, title2 = param.title2, subtitle = param.subtitle, placeholder = param.placeholder, movie = param.movie, accordion = param.accordion, intro = param.intro, fontsize1 = param.fontsize1, fontsize2 = param.fontsize2, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? "primary" : _titleColor;
    return /*#__PURE__*/ _jsxs("section", {
        id: "point-process",
        className: "video-hero wrapper angled lower-start pt-15 pt-md-17",
        children: [
            /*#__PURE__*/ _jsxs("h2", {
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "hero_text",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "fs-".concat(fontsize1),
                                children: title1
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "fs-".concat(fontsize2),
                                children: title2
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        loop: true,
                        playsInline: true,
                        muted: true,
                        poster: placeholder,
                        children: /*#__PURE__*/ _jsx("source", {
                            src: movie,
                            type: "video/mp4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row animate__animated animate__slideInUp animate__delay-2s",
                children: /*#__PURE__*/ _jsx("div", {
                    className: " col-12 mx-auto text-center mt-5"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row animate__animated animate__slideInUp animate__delay-2s",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-10 col-md-11 mx-auto text-center mb-10",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "lead fs-5",
                        children: intro
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row w-100 mb-md-20",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "mx-auto col-sm-10 col-md-8 col-lg-6 col-xl-5",
                    children: /*#__PURE__*/ _jsx("ol", {
                        className: "animate__animated animate__slideInUp animate__delay-3s accordion-wrapper w-100 p-0",
                        id: "accordion",
                        children: accordion.map(function(item) {
                            return /*#__PURE__*/ _jsx(Accordion, _object_spread({}, item), item.no);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var FAQjson = ((/* unused pure expression or super */ null && (FAQjson_FAQ2)));

;// CONCATENATED MODULE: ./src/components/blocks/faq/index.ts










// EXTERNAL MODULE: ./src/components/reuseable/ContactFooterCombo.tsx
var ContactFooterCombo = __webpack_require__(9266);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(4870);
// EXTERNAL MODULE: ./src/hooks/useLogVisitor.js
var useLogVisitor = __webpack_require__(9588);
;// CONCATENATED MODULE: ./pages/index.tsx




// -------- custom component -------- //











var VideoDI = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2920).then(__webpack_require__.bind(__webpack_require__, 2920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2920)
            ];
        }
    }
});
var LocalDI = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4305).then(__webpack_require__.bind(__webpack_require__, 4890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4890)
            ];
        }
    },
    ssr: false
});
var InternationalDI = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 596).then(__webpack_require__.bind(__webpack_require__, 7858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7858)
            ];
        }
    },
    ssr: false
});
var details = {
    pageName: "SEOptimist Agency London",
    categories: "seo, web design",
    description: "Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.",
    parentDirectories: ""
};
var Home = function() {
    (0,useLogVisitor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "SEOptimist London",
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper home",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoDI, {
                                    auditHero: true,
                                    heading: "AI-Driven SEO",
                                    title1: "AI",
                                    title2: "SEO",
                                    title3: "",
                                    movie: "1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: " helps companies significantly improve their Google ranking. We use AI and in-house automation tools to boost sales."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "ai-seo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(process/* Process1 */.G, {
                                title: "",
                                subtitle: "AI For Faster Growth",
                                body: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "lead",
                                        children: "Dominate your industry online with our AI-powered SEO automation: Unlock quick wins, boost your revenue, and secure your spot \n                at the top of Google effortlessly."
                                    }, "100"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "lead",
                                        children: 'Our in-house tools download the details of every website in your industry, analyse all their keywords, Google positions and backlinks. \n                Then we compare this data with your site. We make a list of all the "quick wins" we can add to your site to get short term success. \n                 The resulting increase in turnover will demonstrate the benefit of our service and justify sticking with as we establish you at the top of Google for the keywords of your industry.'
                                    }, "101"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "lead text-capitalize",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                                className: "more hover ",
                                                href: "/blog/".concat(keywords.AI[0].title.toLowerCase().replace(/ /g, "-")),
                                                title: keywords.AI[0].title
                                            }),
                                            " "
                                        ]
                                    }, "102")
                                ],
                                list: data_process/* processList1 */.vz,
                                buttonLink: "/#contact",
                                buttonTitle: "Get in touch",
                                displayButton: "d-inline",
                                src: "/img/".concat(keywords.AI[10].title.toLowerCase().replace(/ /g, "-"), "-2.png"),
                                alt: keywords.AI[0].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "localSEO",
                                className: "mt15"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalDI, {
                                heading: keywords.localSEOPackages[1].title,
                                initialslide: 0,
                                body: "Our local & Technical SEO, Social & PPC services target your exact demographic in the UK."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternationalDI, {
                                heading: "".concat(keywords.HomeList[9].title, "s"),
                                body: "Our ".concat(keywords.HomeList[9].title, "s have developed SEO straegies and multilingual software for the biggest tech companies in\n                    the USA. We apply the same strategies to make your site visible in searches for European keywords.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial/* Director */.tw, {
                                title: keywords.HomeList[6].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio/* Portfolio2 */.sc, {
                                title: "".concat(keywords.HomeList[7].title, "s")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_FAQ2, {
                                title1: "10 POINT",
                                title2: "PROCESS",
                                movie: "technical-seo-agency.webm",
                                // movie="https://www.shutterstock.com/shutterstock/videos/1052689403/preview/stock-footage-digital-city-seamless-loop-abstract-d-hologram-render-with-futuristic-matrix-flying-through.webm"
                                placeholder: "1-bg.jpg",
                                body: "",
                                // body={`SEOptimist has developed a 10 Point PROCESS to stay focused only on the on-page, off-page and ${All.HomeList[8].title} that really affect your search results.
                                // The bottom line is AI can help you create better optimised content that your readers will love and engage with.`}
                                subtitle: keywords.HomeList[8].title,
                                accordion: accordionList2,
                                titleColor: "muted",
                                fontsize1: 110,
                                fontsize2: 100
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(services/* Services22 */.m9, {
                                title: "",
                                wordCloud: keywords
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFooterCombo/* default */.Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
//@ts-expect-error - gen
Home.bodyClass = "transparent";
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,7857,7727,4870,4556,6435,362,4022,3882,659,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);